import { useMemo } from "react";
import type { VenueConfig } from "../../../common/jsonRpcTypes";
import type { AppliedVoucher } from "./useVoucherRedemption";

/**
 * Handle display-related calculations for payment components.
 * Extracted from PaymentStep to reduce cognitive complexity.
 */
export const usePaymentDisplay = (
  venueConfig: VenueConfig | null,
  isAuthOnly: boolean,
  paymentAmount: number,
  appliedVouchers: AppliedVoucher[],
  remainingAmount: number,
) => {
  // Calculate amount to pay on card for non-voucher flow
  const getAmountToPayOnCardWithoutVouchers = useMemo(() => {
    return paymentAmount;
  }, [paymentAmount]);

  // Calculate amount to pay on card for voucher flow
  const getAmountToPayOnCardWithVouchers = useMemo(() => {
    return remainingAmount;
  }, [remainingAmount]);

  // Check if fully redeemed for non-voucher flow (always false)
  const getIsFullyRedeemedWithoutVouchers = useMemo(() => {
    return false;
  }, []);

  // Check if fully redeemed for voucher flow
  const getIsFullyRedeemedWithVouchers = useMemo(() => {
    return appliedVouchers.length > 0 && remainingAmount <= 0;
  }, [appliedVouchers, remainingAmount]);

  return {
    getAmountToPayOnCardWithoutVouchers,
    getAmountToPayOnCardWithVouchers,
    getIsFullyRedeemedWithoutVouchers,
    getIsFullyRedeemedWithVouchers,
  };
};
